'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var _asyncToGenerator = require('@babel/runtime/helpers/asyncToGenerator');
var _classCallCheck = require('@babel/runtime/helpers/classCallCheck');
var _createClass = require('@babel/runtime/helpers/createClass');
var core = require('@landr/core');
var core_models = require('@landr/core.models');
var EventIds = require('./EventIds.cjs');
var typesPrivate = require('./typesPrivate.cjs');
var analyticsHelpers = require('./utils/analyticsHelpers.cjs');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);

function _regeneratorRuntime() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
// As it's used on the app bootstrap, let's retry 3 times max.
// it will lead to 0 + 300 + 600 + 1200 = 2100ms of retry delay (without counting the API timeout/call delay)
var MaxApiCallRetryCount = 3;
var AuthService = /*#__PURE__*/function () {
  function AuthService(_ref) {
    var authProvider = _ref.authProvider,
      platformProvider = _ref.platformProvider,
      homepageForAnalyticsFallback = _ref.homepageForAnalyticsFallback,
      environment = _ref.environment,
      log = _ref.log;
    _classCallCheck__default["default"](this, AuthService);
    this.logOnBehalfToken = void 0;
    this.utmParams = void 0;
    this.userUrl = void 0;
    this.homepageForAnalyticsFallback = void 0;
    this.checkAuthenticationPromise = null;
    this.authState = null;
    this.authProvider = void 0;
    this.platformProvider = void 0;
    this.log = void 0;
    this.getUserPromise = null;
    this.reconcileApiResponse = null;
    this.authProvider = authProvider;
    this.platformProvider = platformProvider;
    this.logOnBehalfToken = platformProvider.getLogOnBehalfValue();
    this.utmParams = platformProvider.getUTMParams();
    this.log = log;
    this.userUrl = core.getMsApiUri(environment, 'user');
    this.homepageForAnalyticsFallback = homepageForAnalyticsFallback;
  }

  /**
   * Will check authentication from code/state parameters of platform provider, or
   * will try to silently authenticate the user using existing tokens.
   * @return true if user is authenticated silently
   */
  _createClass__default["default"](AuthService, [{
    key: "checkOrWaitForOngoingAuthentication",
    value: function checkOrWaitForOngoingAuthentication() {
      var _this$platformProvide,
        _this$platformProvide2,
        _this = this;
      // On SSR, we don't need to check authentication at all
      // After that, all `getUser` / `getAccessToken` / `getAnalyticsProperties` will return unauthenticated values
      if ((_this$platformProvide = (_this$platformProvide2 = this.platformProvider).isServerSideRendering) === null || _this$platformProvide === void 0 ? void 0 : _this$platformProvide.call(_this$platformProvide2)) {
        return Promise.resolve(false);
      }
      if (!this.checkAuthenticationPromise) {
        this.checkAuthenticationPromise = this.authProvider.init().then(function () {
          return _this.checkAuthenticationAndSilentLogin();
        });
      }
      return this.checkAuthenticationPromise;
    }
  }, {
    key: "checkAuthenticationAndSilentLogin",
    value: function () {
      var _checkAuthenticationAndSilentLogin = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this$platformProvide3, code, state, error, errorDescription, hasBeenHandledValue, isAuthenticated, userIsInCorruptedState;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$platformProvide3 = this.platformProvider.readStateAndCode(), code = _this$platformProvide3.code, state = _this$platformProvide3.state, error = _this$platformProvide3.error, errorDescription = _this$platformProvide3.errorDescription; // This method has been moved to a protected method to allow reusing it in the mobile flow
              // where the code will be retrieved async and not on app load like on the web.
              _context.next = 3;
              return this.handleCodeStateAndError({
                code: code,
                state: state,
                error: error,
                errorDescription: errorDescription
              });
            case 3:
              hasBeenHandledValue = _context.sent;
              if (!(hasBeenHandledValue !== undefined)) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return", hasBeenHandledValue);
            case 6:
              _context.next = 8;
              return this.authProvider.silentlyCheckLogin();
            case 8:
              isAuthenticated = _context.sent;
              if (!isAuthenticated) {
                _context.next = 17;
                break;
              }
              _context.next = 12;
              return this.userExistsInDb();
            case 12:
              userIsInCorruptedState = !_context.sent;
              if (!userIsInCorruptedState) {
                _context.next = 17;
                break;
              }
              _context.next = 16;
              return this.logout();
            case 16:
              return _context.abrupt("return", false);
            case 17:
              return _context.abrupt("return", isAuthenticated);
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function checkAuthenticationAndSilentLogin() {
        return _checkAuthenticationAndSilentLogin.apply(this, arguments);
      }
      return checkAuthenticationAndSilentLogin;
    }()
  }, {
    key: "handleCodeStateAndError",
    value: function () {
      var _handleCodeStateAndError = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref2) {
        var state, code, error, errorDescription, currentAuthState, _yield$this$authProvi, authState, isOAuthError, logLevel, _error, _errorDescription;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              state = _ref2.state, code = _ref2.code, error = _ref2.error, errorDescription = _ref2.errorDescription;
              if (!error) {
                _context2.next = 6;
                break;
              }
              this.log.warn('Error while authenticating the user', EventIds.AuthEventIds.RedirectError, {
                error: error,
                errorDescription: errorDescription
              });
              _context2.next = 5;
              return this.authProvider.handleError(error, errorDescription);
            case 5:
              return _context2.abrupt("return", false);
            case 6:
              if (!code) {
                _context2.next = 41;
                break;
              }
              _context2.prev = 7;
              _context2.next = 10;
              return this.authProvider.validateCodeAndState({
                code: code,
                state: state
              });
            case 10:
              _yield$this$authProvi = _context2.sent;
              authState = _yield$this$authProvi.authState;
              currentAuthState = authState;
              this.authState = authState;
              _context2.next = 22;
              break;
            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](7);
              this.log.warn('Error validating code and state', EventIds.AuthEventIds.ValidateCodeAndStateError, _context2.t0, {
                referrer: this.platformProvider.getDocumentReferrer()
              });
              _context2.next = 21;
              return this.redirectToLoginWithError(typesPrivate.AuthServiceCustomErrors.CodeAndStateValidationError, 'Error validating code and state');
            case 21:
              return _context2.abrupt("return", false);
            case 22:
              _context2.prev = 22;
              _context2.next = 25;
              return this.reconcileData(currentAuthState);
            case 25:
              this.platformProvider.onAppState(this.authState.appState);
              this.log.info('Authenticated with success', EventIds.AuthEventIds.AuthenticatedWithSuccess);
              return _context2.abrupt("return", true);
            case 30:
              _context2.prev = 30;
              _context2.t1 = _context2["catch"](22);
              isOAuthError = _context2.t1 instanceof typesPrivate.OAuthError;
              logLevel = isOAuthError ? 'warn' : 'error';
              this.log[logLevel]('Failed to reconcile user data', EventIds.AuthEventIds.ReconcileAuthUserFailed, _context2.t1);
              _error = typesPrivate.AuthServiceCustomErrors.ReconcileError;
              _errorDescription = 'Failed to reconcile user data';
              if (isOAuthError) {
                _error = _context2.t1.errorCode;
                _errorDescription = _context2.t1.message;
              }
              _context2.next = 40;
              return this.redirectToLoginWithError(_error, _errorDescription);
            case 40:
              return _context2.abrupt("return", false);
            case 41:
              return _context2.abrupt("return", undefined);
            case 42:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[7, 16], [22, 30]]);
      }));
      function handleCodeStateAndError(_x) {
        return _handleCodeStateAndError.apply(this, arguments);
      }
      return handleCodeStateAndError;
    }()
    /**
     * Open or redirect the user to the login/signup flow
     * @param loginParameters AuthState parameters that will be stored locally and used to reconcile data
     * @returns OAuth parameters if the flow is done async (e.g. on mobile), or redirect to login if the flow is done sync (e.g. on web)
     */
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref3) {
        var _ref4;
        var _ref3$appState, appState, _ref3$isSignup, isSignup, homePageFromParams, _ref3$locale, locale, migrateAssetsOnSignup, forceLoginPrompt, homePage, authState;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _ref3$appState = _ref3.appState, appState = _ref3$appState === void 0 ? {} : _ref3$appState, _ref3$isSignup = _ref3.isSignup, isSignup = _ref3$isSignup === void 0 ? false : _ref3$isSignup, homePageFromParams = _ref3.homePage, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? core_models.DefaultLanguage : _ref3$locale, migrateAssetsOnSignup = _ref3.migrateAssetsOnSignup, forceLoginPrompt = _ref3.forceLoginPrompt;
              if (!appState.targetUrl) {
                appState.targetUrl = this.platformProvider.getTargetUrl();
              }
              // Homepage can be set from several provenances:
              // - from the params (e.g. when the developer wants a specific homepage
              //   (this is the most common case on main app using multiple MFEs and one single auth service)
              // - from the platform provider (e.g. when the user is redirected from outside [blog, guest site])
              // - from the default homepage (e.g. when the authentication flow is used in a single repo - network, samples, etc.)
              homePage = (_ref4 = homePageFromParams !== null && homePageFromParams !== void 0 ? homePageFromParams : this.platformProvider.getDefaultHomePage()) !== null && _ref4 !== void 0 ? _ref4 : this.homepageForAnalyticsFallback;
              authState = {
                appState: appState,
                homePage: homePage,
                utmParams: this.utmParams,
                locale: locale,
                logOnBehalfToken: this.logOnBehalfToken,
                migrateAssetsOnSignup: migrateAssetsOnSignup,
                documentReferrer: this.platformProvider.getDocumentReferrer()
              };
              return _context3.abrupt("return", this.authProvider.redirectToLogin(authState, {
                isSignup: isSignup,
                locale: locale,
                forceLoginPrompt: forceLoginPrompt
              }));
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function login(_x2) {
        return _login.apply(this, arguments);
      }
      return login;
    }()
    /**
     * Redirect the user to the login/signup flow with an error displayed
     * @param error A know "string" of error. See AuthProvider documentations for more details.
     * @param errorDescription  A human readable of the error for logs
     * @returns Redirect the user to the login/signup flow
     */
  }, {
    key: "redirectToLoginWithError",
    value: function redirectToLoginWithError(error, errorDescription) {
      return this.authProvider.handleError(error, errorDescription);
    }

    /**
     * Logout the user and redirect to the returnTo url if any
     * @param returnTo The URL to redirect the user to after logout
     * @returns Redirect the user to the logout flow
     */
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(returnTo) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.platformProvider.resetAnalytics();
              this.platformProvider.clearLogOnBehalfValue();

              // Reset local data
              this.getUserPromise = null;
              this.reconcileApiResponse = null;
              this.authState = null;
              this.checkAuthenticationPromise = null;
              return _context4.abrupt("return", this.authProvider.logout(returnTo !== null && returnTo !== void 0 ? returnTo : this.platformProvider.getRootUrl()));
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function logout(_x3) {
        return _logout.apply(this, arguments);
      }
      return logout;
    }()
    /**
     * Returns the access token
     * @returns Access token if the user is authenticated, or null if not
     */
  }, {
    key: "getAccessToken",
    value: function () {
      var _getAccessToken2 = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var isAuthenticated;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.isAuthenticated();
            case 2:
              isAuthenticated = _context5.sent;
              if (!isAuthenticated) {
                _context5.next = 5;
                break;
              }
              return _context5.abrupt("return", this._getAccessToken());
            case 5:
              return _context5.abrupt("return", null);
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getAccessToken() {
        return _getAccessToken2.apply(this, arguments);
      }
      return getAccessToken;
    }()
    /**
     * Returns the analytics properties based on a mix of auth state, reconciled data and platform provider data.
     * Please note that there is no analytics data returned after a silent login flow.
     * @returns Analytics properties if the flow needs it, or null if not
     */
  }, {
    key: "getAnalyticsProperties",
    value: function () {
      var _getAnalyticsProperties = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var isAuthenticated, isLoggedOnBehalf;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.isAuthenticated();
            case 2:
              isAuthenticated = _context6.sent;
              if (isAuthenticated) {
                _context6.next = 5;
                break;
              }
              return _context6.abrupt("return", null);
            case 5:
              if (!(this.authState && this.reconcileApiResponse)) {
                _context6.next = 10;
                break;
              }
              _context6.next = 8;
              return this.authProvider.getIsLoggedOnBehalf();
            case 8:
              isLoggedOnBehalf = _context6.sent;
              return _context6.abrupt("return", analyticsHelpers.createAnalyticsProperties({
                authState: this.authState,
                reconcileApiResponse: this.reconcileApiResponse,
                isLoggedOnBehalf: isLoggedOnBehalf,
                targetUrl: this.platformProvider.getTargetUrl(),
                log: this.log
              }));
            case 10:
              return _context6.abrupt("return", null);
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getAnalyticsProperties() {
        return _getAnalyticsProperties.apply(this, arguments);
      }
      return getAnalyticsProperties;
    }()
    /**
     * Returns the app state that was passed before asking login flow.
     * It's used by the app to know what to do after login.
     * @returns AppState if auth flow was done, or null if not
     */
  }, {
    key: "getAppState",
    value: function getAppState() {
      var _this$authState$appSt, _this$authState;
      return (_this$authState$appSt = (_this$authState = this.authState) === null || _this$authState === void 0 ? void 0 : _this$authState.appState) !== null && _this$authState$appSt !== void 0 ? _this$authState$appSt : null;
    }

    /**
     * Returns the value of isSignup collected after the user is reconciled.
     * It's used by the app to know if we redirect to the profile survey or not.
     * @returns Boolean if it is a new signup, false if not
     */
  }, {
    key: "getIsSignup",
    value: function getIsSignup() {
      var _this$reconcileApiRes;
      return !!((_this$reconcileApiRes = this.reconcileApiResponse) === null || _this$reconcileApiRes === void 0 ? void 0 : _this$reconcileApiRes.isSignup);
    }

    /**
     * Returns the authorization header containing the access token.
     * @returns Headers with authorization property, or undefined if not authenticated
     */
  }, {
    key: "getAuthorizationHeader",
    value: function () {
      var _getAuthorizationHeader = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var token;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.getAccessToken();
            case 2:
              token = _context7.sent;
              return _context7.abrupt("return", token ? {
                authorization: "Bearer ".concat(token)
              } : undefined);
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getAuthorizationHeader() {
        return _getAuthorizationHeader.apply(this, arguments);
      }
      return getAuthorizationHeader;
    }()
    /**
     * Returns the user information that is currently authenticated.
     * Note that this method is caching results for the current session.
     * @returns User information if the user is authenticated, or null if not
     */
  }, {
    key: "getUser",
    value: function () {
      var _getUser = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var isAuthenticated;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return this.isAuthenticated();
            case 3:
              isAuthenticated = _context8.sent;
              if (isAuthenticated) {
                _context8.next = 6;
                break;
              }
              return _context8.abrupt("return", null);
            case 6:
              _context8.next = 12;
              break;
            case 8:
              _context8.prev = 8;
              _context8.t0 = _context8["catch"](0);
              this.log.error('Failed to get user', EventIds.AuthEventIds.AuthGetUserError, _context8.t0);
              throw _context8.t0;
            case 12:
              return _context8.abrupt("return", this.loadUserWithCache());
            case 13:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[0, 8]]);
      }));
      function getUser() {
        return _getUser.apply(this, arguments);
      }
      return getUser;
    }()
  }, {
    key: "loadUserWithCache",
    value: function () {
      var _loadUserWithCache = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (!this.getUserPromise) {
                this.getUserPromise = this.loadUser();
              }
              return _context9.abrupt("return", this.getUserPromise);
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function loadUserWithCache() {
        return _loadUserWithCache.apply(this, arguments);
      }
      return loadUserWithCache;
    }()
  }, {
    key: "loadUser",
    value: function () {
      var _loadUser = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _this$authState2, isLoggedOnBehalf, token, response, user;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              _context10.next = 3;
              return this.authProvider.getIsLoggedOnBehalf();
            case 3:
              isLoggedOnBehalf = _context10.sent;
              _context10.next = 6;
              return this._getAccessToken();
            case 6:
              token = _context10.sent;
              _context10.next = 9;
              return core.fetchWithCommonHeaders("".concat(this.userUrl, "/v1/me/profile"), {
                headers: {
                  authorization: "Bearer ".concat(token)
                }
              }, {
                log: this.log,
                retryCount: MaxApiCallRetryCount,
                language: (_this$authState2 = this.authState) === null || _this$authState2 === void 0 ? void 0 : _this$authState2.locale
              });
            case 9:
              response = _context10.sent;
              if (response.ok) {
                _context10.next = 12;
                break;
              }
              throw new Error("HTTP error! Status: ".concat(response.status));
            case 12:
              _context10.next = 14;
              return response.json();
            case 14:
              user = _context10.sent;
              return _context10.abrupt("return", _objectSpread__default["default"](_objectSpread__default["default"]({}, user), {}, {
                isLoggedOnBehalf: isLoggedOnBehalf
              }));
            case 18:
              _context10.prev = 18;
              _context10.t0 = _context10["catch"](0);
              this.log.error('Failed to handle loadUser', EventIds.AuthEventIds.AuthFetchProfileError, _context10.t0);
              throw _context10.t0;
            case 22:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this, [[0, 18]]);
      }));
      function loadUser() {
        return _loadUser.apply(this, arguments);
      }
      return loadUser;
    }()
  }, {
    key: "isAuthenticated",
    value: function isAuthenticated() {
      // By default, on web, the authentication is done on app bootstrap and only once.
      // If the user is not authenticated, we don't need to check again.
      // This flow is different on mobile, on could be override by overriding the `isAuthenticated` method.
      return this.checkOrWaitForOngoingAuthentication();
    }
  }, {
    key: "reconcileData",
    value: function () {
      var _reconcileData = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(authState) {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.reconcileAuthAndMsUser(authState);
            case 2:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function reconcileData(_x4) {
        return _reconcileData.apply(this, arguments);
      }
      return reconcileData;
    }()
  }, {
    key: "reconcileAuthAndMsUser",
    value: function () {
      var _reconcileAuthAndMsUser = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(authState) {
        var _authState$migrateAss, _authState$utmParams, _authState$utmParams2, _authState$utmParams3, _authState$utmParams4, _authState$utmParams5, _this$authState3;
        var isPreviewBeforeSignUp, bodyData, authToken, requestOptions, response, errorType, data;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              isPreviewBeforeSignUp = authState.migrateAssetsOnSignup && ((_authState$migrateAss = authState.migrateAssetsOnSignup) === null || _authState$migrateAss === void 0 ? void 0 : _authState$migrateAss.length) > 0;
              bodyData = {
                homePage: authState.homePage,
                language: authState.locale,
                utmCampaign: (_authState$utmParams = authState.utmParams) === null || _authState$utmParams === void 0 ? void 0 : _authState$utmParams.campaign,
                utmMedium: (_authState$utmParams2 = authState.utmParams) === null || _authState$utmParams2 === void 0 ? void 0 : _authState$utmParams2.medium,
                utmSource: (_authState$utmParams3 = authState.utmParams) === null || _authState$utmParams3 === void 0 ? void 0 : _authState$utmParams3.source,
                utmContent: (_authState$utmParams4 = authState.utmParams) === null || _authState$utmParams4 === void 0 ? void 0 : _authState$utmParams4.content,
                utmTerm: (_authState$utmParams5 = authState.utmParams) === null || _authState$utmParams5 === void 0 ? void 0 : _authState$utmParams5.term,
                documentReferrer: authState.documentReferrer,
                isPreviewBeforeSignUp: isPreviewBeforeSignUp
              };
              _context12.next = 4;
              return this.authProvider.getAccessToken();
            case 4:
              authToken = _context12.sent;
              requestOptions = {
                method: 'POST',
                headers: {
                  Authorization: "Bearer ".concat(authToken),
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(bodyData)
              };
              _context12.next = 8;
              return core.fetchWithCommonHeaders("".concat(this.userUrl, "/v1/me"), requestOptions, {
                log: this.log,
                retryCount: MaxApiCallRetryCount,
                language: (_this$authState3 = this.authState) === null || _this$authState3 === void 0 ? void 0 : _this$authState3.locale
              });
            case 8:
              response = _context12.sent;
              if (response.ok) {
                _context12.next = 22;
                break;
              }
              _context12.prev = 10;
              _context12.next = 13;
              return response.json();
            case 13:
              data = _context12.sent;
              errorType = data.type;
              _context12.next = 19;
              break;
            case 17:
              _context12.prev = 17;
              _context12.t0 = _context12["catch"](10);
            case 19:
              if (!(errorType === typesPrivate.ReconcileApiExceptionType.EmailAlreadyUsed)) {
                _context12.next = 21;
                break;
              }
              throw new typesPrivate.OAuthError('Email aready used', typesPrivate.AuthServiceCustomErrors.EmailAlreadyUsedError);
            case 21:
              throw new Error("HTTP error! Status: ".concat(response.status));
            case 22:
              _context12.next = 24;
              return response.json();
            case 24:
              this.reconcileApiResponse = _context12.sent;
            case 25:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this, [[10, 17]]);
      }));
      function reconcileAuthAndMsUser(_x5) {
        return _reconcileAuthAndMsUser.apply(this, arguments);
      }
      return reconcileAuthAndMsUser;
    }()
  }, {
    key: "userExistsInDb",
    value: function () {
      var _userExistsInDb = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var user;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;
              _context13.next = 3;
              return this.loadUserWithCache();
            case 3:
              user = _context13.sent;
              return _context13.abrupt("return", !!user);
            case 7:
              _context13.prev = 7;
              _context13.t0 = _context13["catch"](0);
              return _context13.abrupt("return", false);
            case 10:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this, [[0, 7]]);
      }));
      function userExistsInDb() {
        return _userExistsInDb.apply(this, arguments);
      }
      return userExistsInDb;
    }()
  }, {
    key: "_getAccessToken",
    value: function () {
      var _getAccessToken3 = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.prev = 0;
              _context14.next = 3;
              return this.authProvider.getAccessToken();
            case 3:
              return _context14.abrupt("return", _context14.sent);
            case 6:
              _context14.prev = 6;
              _context14.t0 = _context14["catch"](0);
              this.log.warn('Error requesting access token', EventIds.AuthEventIds.AccessTokenRequestError, _context14.t0);
              _context14.next = 11;
              return this.redirectToLoginWithError(typesPrivate.AuthServiceCustomErrors.AccessTokenRequestError, 'Error requesting access token');
            case 11:
              return _context14.abrupt("return", null);
            case 12:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this, [[0, 6]]);
      }));
      function _getAccessToken() {
        return _getAccessToken3.apply(this, arguments);
      }
      return _getAccessToken;
    }()
  }]);
  return AuthService;
}();

exports.AuthService = AuthService;
